import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressSpinnerComponent } from './progress-spinner.component';
import { MaterialModule } from 'src/app/material-module';


@NgModule({
  imports: [
    CommonModule,
    MaterialModule
  ],
  providers: [],
  declarations: [ProgressSpinnerComponent]
})
export class ProgressSpinnerModule {}